import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['48px', '48px'],
};

const ExternalLinkIcon = ({ size, style, shouldPadding, ...other }) => {
  size = typeof size === 'string' ? sizes[size] : size;
  const [width, height] = size;

  const svgProps = {
    width,
    height,
    style: Object.assign(shouldPadding ? { padding: '4px' } : {}, style),
    ...other,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...svgProps}
    >
      <path
        fill="currentColor"
        d="M18 5v2h5.563L11.28 19.281l1.438 1.438L25 8.437V14h2V5ZM5 9v18h18V14l-2 2v9H7V11h9l2-2Z"
      />
    </svg>
  );
};
ExternalLinkIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'middle', 'large']),
    PropTypes.array,
  ]),
  shouldPadding: PropTypes.bool,
  style: PropTypes.object,
};
ExternalLinkIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
  style: {},
};

export default ExternalLinkIcon;
